/**
 * Given a JWT, return the parsed payload.
 * @param jwt a fully qualified JWT
 * @param delimiter JWTs should always be delimited with a period (`.`)
 * @returns The payload of the JWT as a JSON object, or null
 */
export const parseToken = (jwt: any, delimiter = '.') => {
  if (!jwt) return null;
  const [header, payload, signature] = jwt.split(delimiter);
  if (payload) {
    const base64Decoded = window.atob(payload);
    return JSON.parse(base64Decoded);
  }
  return null;
};
